<template>
  <div class="header-box">
<!--      <div class="fixed-head">-->
      <div class="w-box">
              <header class="w">
                  <div class="w-box-left">
                      <div class="fl position-info cursorP hover-info" @click="changeCity">
                          <i class="el-icon-location"></i>
                          <span>{{currentAddress}}</span>
                          <i class="el-icon-arrow-down"></i>
                      </div>
                      <div class="fl cursorP" v-if="isLogin">
            <span>
              <router-link to="centerinfo">
                <span class="green-color cursorP">{{userInfo.userName}}</span>
              </router-link>,&nbsp;&nbsp;{{afternoon}}
            </span>
                          <span class="login-out hover-info" @click="loginOut">退出</span>
                      </div>
                      <div v-else class="fl user-info">
                          <span>邦主，你好!</span>
                          <span class="item-center">请</span>
                          <router-link to="login">
                              <span class="green-color cursorP">注册/登录</span>
                          </router-link>
                      </div>
                  </div>
                  <div class="w-box-right">
                      <div class="fl phone-info">
                          <img src="../assets/images/home/top_phone_icon.png" style="margin-bottom: -5px">
                          <span>0571-87221111</span>
                      </div>
                      <div class="fl my cursorP hover-info" @click="toUsercenter">
                          <span>我的青邦</span>
                      </div>
                      <div
                              class="fl download-info cursorP"
                              @mouseenter="onMouseOver"
                              @mouseleave="onMouseOut"
                              :class="showQRCode ? 'white-bg':''"
                      >
                          <i class="iconfont icon-erweima"></i>
                          <span>下载APP</span>
                          <i :class="showQRCode ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                      </div>
                  </div>
                  <div class="clearb QR-code" v-if="showQRCode">
                      <div class="fl QR-code-item">
                          <img src="../assets/images/app_big.png" />
                          <p>APP下载码</p>
                      </div>
                      <div class="fl QR-code-item">
                          <img src="../assets/images/weixin_big.png" />
                          <p>青邦企服公众号</p>
                      </div>
                      <div class="clearb"></div>
                  </div>
              </header>
          </div>
      <div class="head-header-search" :class="showLine?'show-line':''" v-if="showSearch">
              <div class="header-search">
                  <div class="fl logo-info" v-if="specialHead == 1">
                      <router-link  tag="a" target="_blank"  to="/">
                          <img src="../assets/images/test.png" class="logo-img"/>
                          <img src="../assets/images/home/top_slogan.png"  class="home-logo-title mb15"/>
                      </router-link>
                      <!--          <h2 class="logo-title">您的企业管家！</h2>-->
                  </div>
                  <div class="fl logo-info cursorP" v-else @click="clickToModulePage(specialHeadList[(specialHead-2)].path)">
                      <!--         <router-link  tag="a" target="_blank"  :to="">-->
                      <img :src="specialHeadList[(specialHead-2)].headIcon"  class="logo-img"/>
                      <div class="module-head">
                          <h2 class="logo-title module-title">{{specialHeadList[(specialHead-2)].title}}</h2>
                          <p class="sub-title">{{specialHeadList[(specialHead-2)].subTitle}}</p>
                      </div>
                      <!--         </router-link>-->
                  </div>
                  <div class="fl search-cart-info">
                      <div class="fl search-item" id="search-item">

                          <div class="ipt_box" :style="{ borderColor: searchFail ? '#F25A16':'#69AB13' }">
                              <i class="el-input__icon el-icon-search"></i>
                              <input type="text" placeholder="请输入商品关键词" v-model="state2" @keyup.enter="querySearch">
                              <el-button style="border-radius: 0; border: none" :style="{backgroundColor: searchFail ? '#F25A16 !important': '#69ab13 !important'}" slot="append" class="btn-style-info" @click="querySearch">搜索</el-button>
                          </div>

                          <div class="search-hot">
                              <span>热门搜索：</span>
                              <span
                                      class="hot-word"
                                      v-for="(item,index) in popularList"
                                      :key="index"
                                      @click="querySearchItem(item)"
                                      v-show="index<5"
                              >{{item}}</span>
                          </div>
                      </div>
                      <div class="fl common-cursor-pointer" @click="pushToShopcart" style="margin-top: 4px;">
                          <el-badge :value="shopCarNum" class="item" :hidden="shopCarNum==0">
                              <i class="iconfont icon-gouwuche"></i>
                          </el-badge>
                      </div>
                  </div>
                  <div class="cb"></div>
              </div>
          </div>
<!--      </div>-->
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { setStore, getStore, removeStore } from "@/utils/storage";
import { getHotKeywords, getShopcarNum } from "@/api/home";
export default {
  props: ["showSearch", "specialHead","showLine"],
  data() {
    return {
      specialHeadList: [
        {
          headIcon: require("@/assets/images/modulepages/bgcg_logo.png"),
          title: "办公采购",
          subTitle: "全品免邮 质优价廉 快捷送达",
          path: '/officeprocurement',
        },
        {
          headIcon: require("@/assets/images/modulepages/bgzx_logo.png"),
          title: "办公装修",
          subTitle: "免费设计 价优透明 绿色环保",
          path: '/officedecoration',
        },
        {
          headIcon: require("@/assets/images/modulepages/gscs_logo.png"),
          title: "工商财税",
          subTitle: "专业高效  诚信正规  全程代办",
          path: '/businesstax',
        },
        {
          headIcon: require("@/assets/images/modulepages/rcfw_logo.png"),
          title: "人才服务",
          subTitle: "为您招贤纳士 助力创业梦想",
          path: '/humanservice',
        },
        {
          headIcon: require("@/assets/images/modulepages/sbzc_logo.png"),
          title: "商标注册",
          subTitle: "一次托付 全程无忧",
          path: '/trademarkregister',
        },
        {
          headIcon: require("@/assets/images/modulepages/hys_logo.png"),
          title: "会议室预订",
          subTitle: "共享会议室 见证你的奇迹时刻",
          path: '/meetingroombook',
        }
      ],
      popularList: [],
      user: {},
      // 查询数据库的商品
      st: false,
      // 头部购物车显示
      cartShow: false,
      showQRCode: false,
      state2: "",
      activeIndex: "1",
      positionL: 0,
      positionT: 0,
      timerCartShow: null, // 定时隐藏购物车
      input: "",
      choosePage: -1,
      searchResults: [],
      timeout: null,
      token: "",
      navList: [],
      shopCarNum: 0,
      afternoon: '',
      searchFail: false, // 是否无效搜索
    };
  },
  computed: {
    ...mapState(["isLogin", "currentAddress", "userInfo"]),
    isLoginInvalid() {
      return !Boolean(this.$store.state.isLogin);
    }
  },
  mounted() {
    let date = new Date();
    this.afternoon = date.getHours() >= 12 ? '下午好！' : '上午好！';

    if (this.isLogin) {
      this.queryShopcarNum();
    }
    this.$root.eventHub.$on("shopcart-changed", () => {
      this.queryShopcarNum();
    });
    this.getHotKeywords(this.specialHead);
  },
  beforeDestroy() {
    this.$root.eventHub.$off("shopcart-changed");
  },
  methods: {
    ...mapMutations([
      "ADD_CART",
      "INIT_BUYCART",
      "ADD_ANIMATION",
      "SHOW_CART",
      "REDUCE_CART",
      "RECORD_USERINFO",
      "EDIT_CART"
    ]),
    onMouseOver() {
      this.showQRCode = true;
      console.log(this.isLogin);
    },
    onMouseOut() {
      this.showQRCode = false;
    },
      // 获取热门话题
    getHotKeywords(value) {
      var type = value - 1;
      if (value == 1) {
        type = "";
      }
      var params = {
        type: type + ""
      };
      getHotKeywords(params)
        .then(res => {
          if (res.data.code === 0) {
            var dataList = res.data.data.list;
            this.popularList = dataList;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
      clickToModulePage(url){
          var urlInfo = this.$router.resolve({ path: url });
          window.open(urlInfo.href, '_blank');
      },
    changeCity() {
      this.$router.push({ path: "/changecity" });
    },
    loginOut() {
      var dataDetail = {
        isLogin: false,
        user: {}
      };
      // this.isLogin = false;
      removeStore("isLogin");
      this.$store.commit("EMPTYUSERINFO", dataDetail);
      window.location.href = "/";
    },
    //跳转购物车
    pushToShopcart() {
      if (!this.isLogin) {
        this.$router.push('/login')
      } else {
        this.$router.push('/shopcart')
      }
    },
    //查询采购车数量
    queryShopcarNum() {
      getShopcarNum()
      .then(res => {
        if (res.data.code == 0) {
          this.shopCarNum = res.data.data;
        }
      })
    },
      querySearchItem(item){
          this.state2 = item;
          this.querySearch();
      },
    //搜索传入的相关参数全局搜索type传""字符串keyword：关键词
    querySearch() {
      if(!this.state2.trim()){
        this.searchFail = true;
      }else{
        this.searchFail = false;
      }
      if (!this.state2 || !this.state2.length) {
        return;
      }
      var p = null;
      let listInfo=[];
      if (this.specialHead == 1) {//首页
        // p = {record: [{path: '/', title: '首页'},
        //               {path: '/searchlist', title: this.state2, query: {keyword: this.state2}}]}
          listInfo = [{path: '/', title: '首页'},
              {path: '/searchlist', title: this.state2, keyword: this.state2}];
      } else {
        const el = this.specialHeadList[(this.specialHead-2)];
        // p = {record: [{path: el.path, title: el.title},
        //               {path: '/searchlist', title: this.state2, query: {keyword: this.state2}}]};
        listInfo = [{path: el.path, title: el.title},
            {path: '/searchlist', title: this.state2,keyword: this.state2}];
      }

      // let urlInfo = this.$router.resolve({
      //   path: "/searchlist",
      //   query: { p: JSON.stringify(p) }
      // });
      //   this.$setCookie("searchRecord",JSON.stringify(listInfo));
        window.localStorage.setItem("searchRecord",JSON.stringify(listInfo))

        let urlInfo = this.$router.resolve({path: "/searchlist"});
        window.open(urlInfo.href,'_blank')
    },
    toUsercenter() {
      if (this.isLoginInvalid) {
          let urlInfo = this.$router.resolve({ path: "/login" });
          window.open(urlInfo.href,'_blank')
      } else {
          let urlInfo = this.$router.resolve({ path: "/centerinfo" });
          window.open(urlInfo.href,'_blank')
      }
    },
    handleSelect(item) {
      console.log(item);
    }
  },
  components: {},
  watch: {
    isLogin(newValue) {
      if (!newValue) {
        this.shopCarNum = 0;
      } else {
        this.queryShopcarNum();
      }
    },
      //获取热门搜索
      specialHead(newValue, oldValue) {
          this.getHotKeywords(newValue);
      }
  }
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
    .fixed-head{
        position: fixed;
        height: 140px;
        width: 100%;
        margin: 0 auto;
        z-index: 11;
        background: white;
    }
.header-box {
  width: 100%;
    position: relative;
}
.w-box {
  background: #f0f0f0;
}
.w {
  color: #696969;
  font-size: 14px;
  width: 1100px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  position: relative;
}
header {
  position: relative;
}
.position-info {
  margin-right: 65px;
}
.item-center {
  margin-left: 15px;
  margin-right: 5px;
}
.w-box-right {
  position: absolute;
  right: 0;
}
.login-out {
  margin-left: 30px;
}
.download-info {
  padding: 0 10px;
}
.white-bg {
  background: white;
  color: #69ab13;
}
.QR-code {
  position: absolute;
  right: -66px;
  top: 40px;
  background: white;
  z-index: 9;
  border: 1px solid #f0f0f0;
  border-top: none;
  padding: 10px;
}
.QR-code-item img {
  width: 75px;
}
.QR-code-item {
  text-align: center;
  width: 120px;
}
.QR-code-item p {
  height: 15px;
  line-height: 0;
  font-size: 14px;
}
.my {
  margin-right: 65px;
  margin-left: 70px;
}
.green-color {
  color: #69ab13;
}
.head-header-search {
  width: 100%;
  /*border-bottom: 3px solid #69AB13;*/
}
.show-line{
    border-bottom: 2px solid #69AB13;
}
.header-search {
  width: 1100px;
  margin: 0 auto;
  position: relative;
  height: 100px;
  padding-top: 15px;
  /*line-height: 120px;*/
}
.logo-info {
  display: flex;
}
.logo-info .logo-img {
  width: 58px;
  height: 58px;
}
.home-logo-title{
    margin-left: 20px;
    width: 213px;
    height: 28px;
}
.logo-title {
  margin-left: 20px;
  height: 58px;
  line-height: 58px;
  color: #333333;
  font-size: 30px;
  font-weight: 400;
}
.module-head {
  margin-left: 20px;
}
.module-title {
  margin-left: 0;
  height: 38px;
  font-size: 20px;
  line-height: 38px;
  font-weight: bold;
}
.sub-title {
  color: #a9a9a9;
}
.search-cart-info {
  position: absolute;
  right: 0;
  top: 25px;
}
.search-item {
  margin-right: 28px;
  .ipt_box{
    height: 42px;
    border: 2px solid #69AB13;
    i{
        color: #A4A4A4;
      float: left;
      font-size: 18px;
      margin: 0 6px;
    }
    input{
      width: 423px;
      height: 38px;
      float: left;
      border: none;
      outline: none;
      font-size: 14px;
    }
  }
}
// #search-item .el-input .el-input__inner{
// #search-item .el-input input{
//     border: 2px solid red !important;
// }
.search-hot {
  margin-top: 5px;
  margin-left: 10px;
  color: #a5a5a5;
}
.hot-word {
  margin-right: 10px;
  cursor: pointer;
}
.hot-word:hover {
  color: #69ab13;
}
.btn-style-info {
  background-color: #69ab13 !important;
  color: white !important;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  // border: 1px solid #69ab13 !important;
  width: 90px;
}
.search-cart-info .iconfont {
  font-size: 28px;
}
.icon-gouwuche{
    color: #AEAEAE;
}
a {
    color:#696969;
  text-decoration: none;
}
    a:visited{
        color:#696969;
    }
.hover-info:hover{
    color: #69AB13;
}
    /*@media screen and (max-width: 1600px) {*/
    /*    .header-box {*/
    /*        -ms-transform: scale(0.8); 		!* IE 9 *!*/
    /*        -ms-transform-origin:center top;		!* IE 9 *!*/
    /*    }*/
    /*}*/
</style>




// WEBPACK FOOTER //
// src/components/header.vue